import { Component } from '@angular/core';

@Component({
  selector: 'stc-apps-test-history-icon',
  templateUrl: './clock-icon.component.svg',
  styleUrls: ['./clock-icon.component.scss'],
})
export class TestHistoryIconComponent {}
